import type { AuthenticatedUser, LoginRequest, LoginResponse } from '@oxxean/types';
import { http, setCsrfToken, type PaRequestConfig } from '../http';

/** Un 401 en estas rutas es una credencial inválida, no una sesión expirada. */
const NO_REFRESH: PaRequestConfig = { paSkipRefresh: true };

export async function login(payload: LoginRequest): Promise<LoginResponse> {
  const response = await http.post<LoginResponse>('/auth/login', payload, NO_REFRESH);
  setCsrfToken(response.data.csrfToken);
  return response.data;
}

export async function fetchCurrentUser(): Promise<AuthenticatedUser> {
  const response = await http.get<AuthenticatedUser>('/auth/me');
  return response.data;
}

export async function logout(): Promise<void> {
  try {
    await http.post('/auth/logout', undefined, NO_REFRESH);
  } finally {
    setCsrfToken(null);
  }
}

export interface ChangePasswordPayload {
  currentPassword: string;
  newPassword: string;
}

export async function changePassword(payload: ChangePasswordPayload): Promise<void> {
  await http.post('/auth/change-password', payload);
}

export async function requestPasswordReset(email: string): Promise<void> {
  await http.post('/auth/forgot-password', { email }, NO_REFRESH);
}

export interface ResetPasswordPayload {
  token: string;
  newPassword: string;
}

export async function resetPassword(payload: ResetPasswordPayload): Promise<void> {
  await http.post('/auth/reset-password', payload, NO_REFRESH);
}
